import { Directive, HostListener, Optional } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[jniNumberOnlyWithTwoDecimals]",
})
export class NumberOnlyWithTwoDecimalsDirective {
  decimales = "00";
  private _oldvalue = "";
  private regExpr = new RegExp("^[+-]?([1-9]\\d*|0)?(\\.\\d{0,2})?$");
  constructor(@Optional() private control: NgControl) {}

  @HostListener("blur", ["$event"])
  blur($event: FocusEvent) {
    if (this.decimales) {
      const item = $event.target as HTMLInputElement;
      const values = item.value.split(".");
      const value =
        values.length > 1
          ? values[0] +
            "." +
            (values[1] + this.decimales).substr(0, this.decimales.length)
          : values[0] + "." + this.decimales;
      if (value !== ".00") {
        this.control?.control?.setValue(value, { emit: false });
      }
    }
  }

  @HostListener("input", ["$event"])
  change($event: Event) {
    const item = $event.target as HTMLInputElement;
    const value = item.value;
    let pos = item.selectionStart ?? 0;
    const matchvalue = value;
    const noMatch: boolean = !this.regExpr.test(matchvalue) && value !== "";
    if (noMatch) {
      item.selectionStart = item.selectionEnd = pos - 1;
      if (item.value.length < this._oldvalue.length && pos == 0) pos = 2;
      if (this.control)
        this.control?.control?.setValue(this._oldvalue, { emit: false });

      item.value = this._oldvalue;
      item.selectionStart = item.selectionEnd = pos - 1;
    } else this._oldvalue = value;
  }
}
